<template>
  <v-col :cols="12" :sm="12" :md="12">
    <Alertas :notificacaoSocket="alertaSocket" :texto="alerta.texto" :tipo="alerta.tipo"></Alertas>

    <v-row>
      <v-col cols="12">
        <v-autocomplete v-model="filtroVazioSelecionado" :items="filtroVazios" label="Filtrar Zerados:" clearable></v-autocomplete>
      </v-col>
    </v-row>

    <DatatableMultiSelecao
      v-show="showSkeletonTable == false"
      :tableTitle="'Produtos Padronizados na Unidade'"
      :printButtonName="'Imprimir Produtos'"
      :tableHeader="headers"
      :tableRows="itens"
      :itemKey="'itemSistemaUnidade.numeroItemSistemaUnidade'"
      :isView="true"
      v-on:datatable-newrow="abrirModalInserir"
      v-on:datatable-viewrow="abrirModalVisualizar"
      v-on:datatable-print="abrirModalVericar"
    ></DatatableMultiSelecao>

    <v-dialog v-model="modalVericar.showModal" max-width="400">
      <template>
        <v-card>
          <v-card-title> <v-row justify="center"> Atenção </v-row> </v-card-title>
          <v-card-text>
            <div class="text-h6 font-weight-regular" align="center" justify="center">
              Mostrar lotes zerados?
            </div>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn @click="gerarEXCEL(modalVericar.itens, true)" class="red--text" text x-large>NÃO</v-btn>
            <v-btn @click="gerarEXCEL(modalVericar.itens, false)" class="green--text" text x-large>SIM</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <SkeletonTable v-show="showSkeletonTable == true" :showSkeletonTable="showSkeletonTable"></SkeletonTable>

    <Loading :open="loading" />

    <ModalCustomSize
      :modalSize="modalCustomSize.size"
      :isTheModalOpen="modalCustomSize.isOpen"
      :modalButtonText="modalCustomSize.buttonText"
      :modalFormTitle="modalCustomSize.formTitle"
      :modalType="modalCustomSize.modalType"
      :isLoadingRequestDisable="modalCustomSize.isLoadingRequestDisable"
      :isModalButtonVisible="modalCustomSize.isButtonsVisible"
      :isModalButtonDisabled="modalCustomSize.isButtonsDisabled"
      v-on:formmodal-close="modalCustomSize.isOpen = false"
      v-on:formmodal-action="inserirItem"
    >
      <div v-if="modalCustomSize.isView">
        <v-row>
          <v-col cols="12">
            <DataTable :tableTitle="'Produtos Vinculados'" :tableHeader="headersItens" :tableRows="listaDeItens"></DataTable>
          </v-col>
        </v-row>
      </div>

      <div v-if="!modalCustomSize.isView">
        <v-form v-model="isFormValid">
          <v-row>
            <v-col cols="12">
              <AlertasModal :tipo="alertaModal.tipo" :texto="alertaModal.texto"></AlertasModal>
            </v-col>

            <v-col cols="6">
              <v-text-field v-model="modalCustomSize.actualEdit.nomeItem" name="nomeItem" label="Nome do Produto" autocomplete="off" :rules="[rules.required, rules.limitCharacters]" counter="255"></v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field v-model="modalCustomSize.actualEdit.descricaoItem" name="descricaoItem" label="Descrição do Produto" counter="255" autocomplete="off"></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </div>
    </ModalCustomSize>
  </v-col>
</template>

<script>
import store from "@/store/index";
import axios from "../plugins/axios";
import DatatableMultiSelecao from "@/components/DatatableMultiSelecao.vue";
import DataTable from "@/components/DataTable2.vue";
import SkeletonTable from "../components/SkeletonTable";
import Loading from "../components/Loading.vue";
import ModalCustomSize from "@/components/ModalCustomSize.vue";
import Alertas from "../components/Alertas.vue";
import AlertasModal from "../components/AlertasModal.vue";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver";

export default {
  components: {
    DatatableMultiSelecao,
    DataTable,
    SkeletonTable,
    Loading,
    ModalCustomSize,
    Alertas,
    AlertasModal,
  },

  data: () => ({
    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    alerta: {
      texto: "",
      tipo: "",
    },

    alertaSocket: {
      texto: "",
      tipo: "",
    },

    alertaModal: {
      texto: "",
      tipo: "",
    },

    isFormValid: false,
    showSkeletonTable: true,
    loading: false,

    headers: [
      {
        text: "ID",
        value: "itemSistemaUnidade.numeroItemSistemaUnidade",
      },
      {
        text: "Nome do Produto",
        value: "itemSistema.nomeItemSistema",
      },
      {
        text: "Descrição do Produto",
        value: "itemSistema.descricaoItemSistema",
      },
      {
        text: "Quantidade Total",
        value: "quantidadeEstoqueTotal",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    headersItens: [
      {
        text: "ID",
        value: "item.numeroItem",
      },
      {
        text: "Lote",
        value: "item.lote",
      },
      {
        text: "Validade",
        value: "item.validade",
      },
      {
        text: "Quantidade Estoque",
        value: "itemUnidade.quantidadeEstoqueItem",
      },
      {
        text: "Família",
        value: "item.indicadorStatusFamilia",
      },
      {
        text: "Subestoque",
        value: "subestoque.nomeSubestoque",
      },
    ],

    modalCustomSize: {
      size: "1400",
      isOpen: false,
      buttonText: "",
      formTitle: "",
      isEdit: false,
      isView: false,
      isLoadingRequestDisable: false,
      isButtonsVisible: true,
      isButtonsDisabled: false,
      actualEdit: {
        descricaoTela: "ItemSistemaUnidade",
        numeroEndereco: store.state.numeroEndereco,
        numeroItemSistemaUnidade: null,
        numeroItemSistema: null,
        nomeItem: null,
        descricaoItem: null,
      },
    },

    modalVericar: {
      showModal: false,
      itens: [],
    },

    filtroVazioSelecionado: false,

    itens: [],
    listaDeItens: [],
    filtroVazios: [
      { value: true, text: "Não retornar vazios" },
      { value: false, text: "Retornar vazios" },
    ],

    rules: {
      required: (value) => !!value || "Requer o campo!",
      limitCharacters: (v) => (v && v.length <= 255) || "Limite de 255 caracteres.",
    },
  }),

  created() {
    this.inicializar();
  },

  watch: {
    isFormValid() {
      this.modalCustomSize.isButtonsDisabled = !this.isFormValid;
    },

    filtroVazioSelecionado() {
      this.inicializar();
    },
  },

  methods: {
    async inicializar() {
      try {
        let response = await axios.put("itemSistemaUnidade", { numeroEndereco: store.state.numeroEndereco, naoRetornarZerados: this.filtroVazioSelecionado, retornarSomenteAtivosNaoZerados: true }, this.config);
        this.itens = response.data;

        this.erro = false;
      } catch (error) {
        console.log(error);
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      } finally {
        this.showSkeletonTable = false;
      }
    },

    async inserirItem() {
      this.alertaModal.tipo = "";
      try {
        await axios.post("itemSistemaUnidade", this.modalCustomSize.actualEdit, this.config);

        this.modalCustomSize.isOpen = false;
        this.showSkeletonTable = true;
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.modalCustomSize.isButtonsDisabled = false;
      } finally {
        this.inicializar();
      }
    },

    abrirModalInserir() {
      this.loading = true;
      this.alertaModal.tipo = "";

      this.modalCustomSize.isOpen = true;
      this.modalCustomSize.isView = false;
      this.modalCustomSize.isEdit = false;
      this.modalCustomSize.isButtonsVisible = true;
      this.modalCustomSize.isButtonsDisabled = !this.isFormValid;
      this.modalCustomSize.formTitle = "Novo Produto";
      this.modalCustomSize.buttonText = "Concluir";

      this.modalCustomSize.actualEdit.numeroItemSistemaUnidade = null;
      this.modalCustomSize.actualEdit.numeroItemSistema = null;
      this.modalCustomSize.actualEdit.nomeItem = null;
      this.modalCustomSize.actualEdit.descricaoItem = null;
      this.loading = false;
    },

    async abrirModalVisualizar(itemSelecionado) {
      this.loading = true;
      this.listaDeItens = [];
      try {
        this.alertaModal.tipo = "";

        const response = await axios.put("infoEstoqueUnidade", itemSelecionado, this.config);
        this.listaDeItens = response.data;
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
      } finally {
        this.modalCustomSize.isView = true;
        this.modalCustomSize.isButtonsDisabled = !this.isFormValid;
        this.modalCustomSize.isButtonsVisible = false;
        this.modalCustomSize.formTitle = "Lista de Produtos";
        this.modalCustomSize.buttonText = "";
        this.modalCustomSize.isOpen = true;
        this.loading = false;
      }
    },

    abrirModalVericar(itens) {
      this.modalVericar.showModal = true;
      this.modalVericar.itens = itens;
    },

    async gerarEXCEL(itensSelecionados, semVazios) {
      this.loading = true;
      try {
        let posicaoLinha = 1;
        const workbook = new Workbook();
        var worksheet = workbook.addWorksheet("Produtos Padronizados", {
          properties: { tabColor: { argb: "FF00FF00" } },
          views: [{ showGridLines: false }],
        });

        worksheet.columns = [
          { key: "col1", width: 20 },
          { key: "col2", width: 30 },
          { key: "col3", width: 30 },
          { key: "col4", width: 30 },
          { key: "col5", width: 20 },
          { key: "col6", width: 20 },
          { key: "col7", width: 20 },
        ];

        worksheet.mergeCells("A" + posicaoLinha + ":G" + posicaoLinha);
        worksheet.getCell("A" + posicaoLinha).value = "Produtos padronizados";
        worksheet.getCell("A" + posicaoLinha).font = { name: "Arial", family: 2, size: 14, bold: true };
        worksheet.getCell("A" + posicaoLinha).alignment = { vertical: "middle", horizontal: "center" };
        worksheet.getCell("A" + posicaoLinha).fill = { type: "pattern", pattern: "solid", fgColor: { argb: "66cc99" } };
        posicaoLinha++;

        worksheet.getCell("A" + posicaoLinha).value = "Nº Produto";
        worksheet.getCell("A" + posicaoLinha).font = { name: "Arial", family: 2, size: 12, bold: true };
        worksheet.getCell("A" + posicaoLinha).alignment = { vertical: "middle", horizontal: "center" };

        worksheet.mergeCells("B" + posicaoLinha + ":C" + posicaoLinha);
        worksheet.getCell("B" + posicaoLinha).value = "Nome do Produto";
        worksheet.getCell("B" + posicaoLinha).font = { name: "Arial", family: 2, size: 12, bold: true };
        worksheet.getCell("B" + posicaoLinha).alignment = { vertical: "middle", horizontal: "center" };

        worksheet.getCell("D" + posicaoLinha).value = "Subestoque";
        worksheet.getCell("D" + posicaoLinha).font = { name: "Arial", family: 2, size: 12, bold: true };
        worksheet.getCell("D" + posicaoLinha).alignment = { vertical: "middle", horizontal: "center" };

        worksheet.getCell("E" + posicaoLinha).value = "Lote";
        worksheet.getCell("E" + posicaoLinha).font = { name: "Arial", family: 2, size: 12, bold: true };
        worksheet.getCell("E" + posicaoLinha).alignment = { vertical: "middle", horizontal: "center" };

        worksheet.getCell("F" + posicaoLinha).value = "Validade";
        worksheet.getCell("F" + posicaoLinha).font = { name: "Arial", family: 2, size: 12, bold: true };
        worksheet.getCell("F" + posicaoLinha).alignment = { vertical: "middle", horizontal: "center" };

        worksheet.getCell("G" + posicaoLinha).value = "Quantidade";
        worksheet.getCell("G" + posicaoLinha).font = { name: "Arial", family: 2, size: 12, bold: true };
        worksheet.getCell("G" + posicaoLinha).alignment = { vertical: "middle", horizontal: "center" };

        posicaoLinha++;

        const listaProdutosComInfo = await Promise.all(itensSelecionados.map(async (itemSelecionado) => {
          itemSelecionado.semVazios = semVazios;

          const response = await axios.put("infoEstoqueUnidade", itemSelecionado, this.config);

          return {
            numeroEndereco: itemSelecionado.numeroEndereco,
            quantidadeEstoqueTotal: itemSelecionado.quantidadeEstoqueTotal,
            semVazios: itemSelecionado.semVazios,
            total: itemSelecionado.total,
            itemSistemaUnidade: itemSelecionado.itemSistemaUnidade,
            itemSistema: itemSelecionado.itemSistema,
            endereco: itemSelecionado.endereco,
            nomeItemSistema: itemSelecionado.itemSistema.nomeItemSistema,
            infosProduto: response.data
          }
        }));
        
        listaProdutosComInfo.sort((a, b) => a.nomeItemSistema.localeCompare(b.nomeItemSistema, 'pt', { sensitivity: 'base' }));

        listaProdutosComInfo.map(async (itemSelecionado) => {
          let posicaoFinal = 0;

          if (itemSelecionado.infosProduto.length > 1) {
            posicaoFinal = posicaoLinha + itemSelecionado.infosProduto.length - 1;
          } else {
            posicaoFinal = posicaoLinha;
          }

          worksheet.mergeCells("A" + posicaoLinha + ":A" + posicaoFinal);
          worksheet.getCell("A" + posicaoLinha).value = itemSelecionado.itemSistemaUnidade.numeroItemSistemaUnidade;
          worksheet.getCell("A" + posicaoLinha).font = { name: "Arial", family: 2, size: 13 };
          worksheet.getCell("A" + posicaoLinha).alignment = { vertical: "middle", horizontal: "center" };

          worksheet.mergeCells("B" + posicaoLinha + ":C" + posicaoFinal);
          worksheet.getCell("B" + posicaoLinha).value = itemSelecionado.itemSistema.nomeItemSistema;
          worksheet.getCell("B" + posicaoLinha).font = { name: "Arial", family: 2, size: 13 };
          worksheet.getCell("B" + posicaoLinha).alignment = { vertical: "middle", horizontal: "start" };

          if (itemSelecionado.infosProduto.length > 0) {
            itemSelecionado.infosProduto.map((infoSelecionada) => {
              worksheet.getCell("D" + posicaoLinha).value = infoSelecionada.subestoque.nomeSubestoque;
              worksheet.getCell("D" + posicaoLinha).font = { name: "Arial", family: 2, size: 13 };
              worksheet.getCell("D" + posicaoLinha).alignment = { vertical: "middle", horizontal: "start" };

              worksheet.getCell("E" + posicaoLinha).value = infoSelecionada.item.lote;
              worksheet.getCell("E" + posicaoLinha).font = { name: "Arial", family: 2, size: 13 };
              worksheet.getCell("E" + posicaoLinha).alignment = { vertical: "middle", horizontal: "start" };

              worksheet.getCell("F" + posicaoLinha).value = infoSelecionada.item.validade;
              worksheet.getCell("F" + posicaoLinha).font = { name: "Arial", family: 2, size: 13 };
              worksheet.getCell("F" + posicaoLinha).alignment = { vertical: "middle", horizontal: "start" };

              worksheet.getCell("G" + posicaoLinha).value = infoSelecionada.itemUnidade.quantidadeEstoqueItem;
              worksheet.getCell("G" + posicaoLinha).font = { name: "Arial", family: 2, size: 13 };
              worksheet.getCell("G" + posicaoLinha).alignment = { vertical: "middle", horizontal: "left" };
              posicaoLinha++;
            });
            worksheet.mergeCells("A" + posicaoLinha + ":E" + posicaoLinha);
            worksheet.getCell("A" + posicaoLinha).fill = { type: "pattern", pattern: "solid", fgColor: { argb: "dadfe1" } };

            worksheet.getCell("F" + posicaoLinha).value = "Total:";
            worksheet.getCell("F" + posicaoLinha).font = { name: "Arial", family: 2, size: 13, bold: true };
            worksheet.getCell("F" + posicaoLinha).alignment = { vertical: "middle", horizontal: "start" };

            worksheet.getCell("G" + posicaoLinha).value = itemSelecionado.quantidadeEstoqueTotal;
            worksheet.getCell("G" + posicaoLinha).font = { name: "Arial", family: 2, size: 13 };
            worksheet.getCell("G" + posicaoLinha).alignment = { vertical: "middle", horizontal: "left" };
            posicaoLinha++;
          } else {
            worksheet.mergeCells("D" + posicaoLinha + ":G" + posicaoLinha);
            worksheet.getCell("D" + posicaoLinha).value = "Não existe um produto vinculado.";
            worksheet.getCell("D" + posicaoLinha).font = { name: "Arial", family: 2, size: 13, bold: false };
            worksheet.getCell("D" + posicaoLinha).alignment = { vertical: "middle", horizontal: "center" };
            posicaoLinha++;
          }
          posicaoLinha++;
        });

        var borderStyles = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };

        worksheet.eachRow({ includeEmpty: true }, function(row) {
          row.eachCell({ includeEmpty: true }, function(cell) {
            cell.border = borderStyles;
          });
        });

        workbook.xlsx.writeBuffer().then(function(data) {
          var blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "Relatório de Produtos.xlsx");
        });

        this.modalVericar.showModal = false;
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
        this.modalVericar.showModal = false;
        this.loading = false;
      }
    },
  },
};
</script>
